var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resumo-das-parcelas", attrs: { tabindex: "1" } },
    [
      _c(
        "button",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.ehMobile && !_vm.mostrarResumoDeParcelas,
              expression: "ehMobile && !mostrarResumoDeParcelas"
            }
          ],
          staticClass:
            "abrir-visualizacao-das-parcelas botao botao_largura-total botao_sem-borda-arredondada botao__com-cursor-de-click botao_gigante",
          attrs: { type: "button", "aria-label": "Continuar a gerar boleto" },
          on: { click: _vm.abrir }
        },
        [_vm._v("Continuar")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.mostrarResumoDeParcelas,
              expression: "mostrarResumoDeParcelas"
            }
          ],
          staticClass: "resumo-das-parcelas__conteudo",
          attrs: { tabindex: "1" }
        },
        [
          _c(
            "div",
            {
              staticClass: "resumo-das-parcelas__bloco u-margem-inferior-media"
            },
            [
              _c(
                "div",
                {
                  staticClass:
                    "grade__linha grade__linha_alinhar-horizontal-centro botao__voltar-lista-de-parcelas",
                  on: { click: _vm.fechar }
                },
                [
                  _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.ehMobile,
                          expression: "ehMobile"
                        }
                      ],
                      staticClass:
                        "botao botao_sem-preenchimento botao_grande botao_icone",
                      attrs: { "aria-label": "voltar para listagem de boletos" }
                    },
                    [
                      _c("i", {
                        staticClass:
                          "fal fa-chevron-down u-texto-alinhado-ao-centro"
                      })
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c("table", { staticClass: "tabela tabela_com-largura-total" }, [
                _c(
                  "caption",
                  {
                    staticClass:
                      "titulo titulo_pequeno u-texto-alinhado-a-esquerda u-margem-pequena"
                  },
                  [_vm._v("Resumo das parcelas selecionadas")]
                ),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v("Quantidade de parcelas")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v(_vm._s(_vm.quantidadeDeParcelas))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v("Subtotal das parcelas")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v("R$ " + _vm._s(_vm.subtotalDasParcelas))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [_vm._v("Correção")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("R$ " + _vm._s(_vm.valorDeCorrecao))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v("Juros de mora")
                    ]),
                    _vm._v(" "),
                    _c("td", [_vm._v("R$ " + _vm._s(_vm.valorDeMora))])
                  ]),
                  _vm._v(" "),
                  _c("tr", [
                    _c("th", { attrs: { scope: "row" } }, [_vm._v("Multa")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("R$ " + _vm._s(_vm.valorDeMulta))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tr",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.valorDeDesconto > 0,
                          expression: "valorDeDesconto > 0"
                        }
                      ]
                    },
                    [
                      _vm._m(0),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          " R$ " +
                            _vm._s(
                              _vm.formatarValorMonetarioParaExibicao(
                                _vm.valorDeDesconto
                              )
                            )
                        )
                      ])
                    ]
                  )
                ])
              ])
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.valorDeDesconto > 0,
                  expression: "valorDeDesconto > 0"
                }
              ],
              staticClass:
                "botao botao_altura_automatica botao_largura-total botao-acao-primaria u-margem-inferior-media u-padding-media",
              attrs: {
                disabled: _vm.parcelasSelecionadas.length < 1,
                tabindex: "1",
                type: "button"
              },
              on: {
                click: function($event) {
                  return _vm.emitirBoleto(true)
                }
              }
            },
            [
              _c("span", { staticClass: "valor-total-das-parcelas" }, [
                _c("i", { staticClass: "fal fa-barcode" }),
                _vm._v(
                  "\n                R$ " +
                    _vm._s(
                      _vm.formatarValorMonetarioParaExibicao(
                        _vm.valorTotalDasParcelasSelecionadas -
                          _vm.valorDeDesconto
                      )
                    ) +
                    "\n            "
                )
              ]),
              _vm._v("\n            Emitir boleto com desconto\n        ")
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.valorDeDesconto <= 0,
                  expression: "valorDeDesconto <= 0"
                }
              ],
              staticClass:
                "botao botao_altura_automatica botao_largura-total botao-vermelho-secundario u-padding-mini",
              attrs: {
                disabled: _vm.parcelasSelecionadas.length < 1,
                tabindex: "1",
                type: "button"
              },
              on: {
                click: function($event) {
                  return _vm.emitirBoleto(false)
                }
              }
            },
            [
              _c("span", { staticClass: "valor-total-das-parcelas" }, [
                _c("i", { staticClass: "fal fa-barcode" }),
                _vm._v(
                  "\n                R$ " +
                    _vm._s(
                      _vm.formatarValorMonetarioParaExibicao(
                        _vm.valorTotalDasParcelasSelecionadas
                      )
                    ) +
                    "\n            "
                )
              ]),
              _vm._v("\n            Emitir boleto sem desconto\n        ")
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("th", { attrs: { scope: "row" } }, [
      _c("strong", [_vm._v("Descontos")])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fb300a32", { render: render, staticRenderFns: staticRenderFns })
  }
}